<template>
  <transition name="fade">
    <div :class="{snackBar: true, hasAction: action}" v-if="show">
      <span v-html="content"/>
      <div class="action" v-if="action" v-on:click="close(true)">
        {{action}}
      </div>
      <div class="close" v-on:click="close(false)"></div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      content: '',
      action: null,
      next: null,
      time: null,
    };
  },
  methods: {
    open(d, n) {
      this.content = d.content;
      this.action = d.action;
      this.next = n;
      this.show = true;
      if (this.time) clearTimeout(this.time);
      const sec = (this.action) ? 5000 : 1200;
      setTimeout(() => {
        this.close(false);
      }, sec);
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
  .snackBar{
    position: fixed;
    bottom: 30px;
    right: 40px;
    background-color: #222;
    border-radius: 5px;
    color: #ccc;
    padding: 10px 16px 8px;
    box-shadow: 2px 2px 6px rgba(0,0,0,.3);
    padding-right: 50px;
    z-index: 999;
    font-weight: normal;
    &.hasAction{
      padding-right: 120px;
    }
    @media (max-width: 768px) {
      bottom: 14px;
      right: 14px;
    }
    span{
      display: inline-block;
      max-width: 440px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .action{
      color: #69a2f7;
      font-weight: 600;
      font-weight: bold;
      position: absolute;
      top: 5px;
      right: 42px;
      height: 27px;
      padding: 4px 10px 0;
      border-radius: 4px;
      cursor: pointer;
    }
    .action:hover{
      background-color: #333;
    }
    .close{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: absolute;
      background-image: url(../assets/close-white.png);
      background-repeat: no-repeat;
      background-size: 10px auto;
      background-position: center;
      right: 6px;
      top: 5px;
      cursor: pointer;
    }
    .close:hover{
      background-color: #333;
    }
  }
</style>
